export {
  TermsPage as default,
  getStaticProps,
  getStaticPaths
} from "~/wrappers/TermsPage";
